"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "seravezza": {
    "a6aa5bab": [{
      "hkey": "fa114c81",
      "slug": "seravezza",
      "name": "Seravezza",
      "primary": true,
      "skipSearch": false
    }],
    "cerreta-san-nicola": [{
      "hkey": "fa114c81",
      "slug": "seravezza",
      "name": "Seravezza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "340e4057": [{
      "hkey": "b4efb5bd",
      "slug": "fabbiano",
      "name": "Fabbiano",
      "primary": true,
      "skipSearch": false
    }],
    "fabiano": [{
      "hkey": "b4efb5bd",
      "slug": "fabbiano",
      "name": "Fabbiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "399dce52": [{
      "hkey": "4357b1a3",
      "slug": "ripa-pozzi",
      "name": "Ripa-Pozzi",
      "primary": true,
      "skipSearch": false
    }],
    "pozzi": [{
      "hkey": "4357b1a3",
      "slug": "ripa-pozzi",
      "name": "Ripa-Pozzi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;